/**
 * Create Currencies context for custom hook
 */


import { createContext } from 'react'

const CurrenciesContext = createContext({
  currencies: [],
  currenciesReady: false
})

export default CurrenciesContext
